import React from "react";
import { Link } from "react-router-dom";

export default function Success() {
  const styles = {
    page: { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#0b0d12", color: "#e6e9f2" },
    wrap: { width: "100%", maxWidth: 720, padding: "40px 16px", boxSizing: "border-box" },
    card: { border: "1px solid rgba(255,255,255,.08)", background: "rgba(255,255,255,.04)", borderRadius: 14, padding: 24 },
    h1: { margin: "0 0 12px 0", fontSize: 28, lineHeight: 1.2 },
    lead: { color: "#a5acc3", marginTop: 10 },
    steps: { listStyle: "none", padding: 0, margin: "18px 0 6px 0" },
    li: { padding: "10px 0", borderTop: "1px solid rgba(255,255,255,.08)" },
    row: { display: "flex", gap: 12, flexWrap: "wrap", marginTop: 18 },
    btn: { display: "inline-block", padding: "10px 14px", borderRadius: 10, background: "#111827", color: "#fff", border: "1px solid rgba(255,255,255,.08)", textDecoration: "none" },
    btnSecondary: { display: "inline-block", padding: "10px 14px", borderRadius: 10, background: "transparent", color: "#cbd5ff", border: "1px solid rgba(255,255,255,.08)", textDecoration: "none" },
    badge: { display: "inline-block", fontSize: 12, padding: "4px 8px", borderRadius: 999, border: "1px solid rgba(255,255,255,.08)", background: "rgba(255,255,255,.03)", color: "#a5acc3", marginBottom: 10 }
  };

  return (
    <div style={styles.page}>
      <div style={styles.wrap}>
        <div style={styles.card}>
          <span style={styles.badge}>Blackout Games — Programme pilote</span>
          <h1 style={styles.h1}>Merci, votre demande est bien reçue ✅</h1>
          <p style={styles.lead}>
            Nous revenons vers vous sous <strong>7 jours ouvrés</strong> avec les prochaines étapes.
          </p>
          <ul style={styles.steps}>
            <li style={styles.li}><strong>1) Confirmation par e-mail :</strong> pensez à vérifier vos spams. Expéditeur : <em>blackoutgames.fr@gmail.com</em>.</li>
            <li style={styles.li}><strong>2) Court questionnaire :</strong> 3–4 questions (taille d’équipe, langue, créneaux) pour organiser la bêta.</li>
            <li style={styles.li}><strong>3) Réservation d’un créneau :</strong> la bêta (15–20 min, 2–3 énigmes) se déroule entre janvier et février selon vos préférences.</li>
            <li style={styles.li}><strong>4) Avantage pilote :</strong> en échange de votre feedback, vous recevrez <em>une session complète offerte</em> au lancement.</li>
          </ul>
          <div style={styles.row}>
            <Link to="/" style={styles.btn}>← Revenir à l’accueil</Link>
            <a href="mailto:blackoutgames.fr@gmail.com" style={styles.btnSecondary}>Contactez-nous</a>
          </div>
        </div>
      </div>
    </div>
  );
}
